import {
  Action,
  AnyAction,
  combineReducers,
  configureStore,
  Reducer,
  ThunkAction
} from '@reduxjs/toolkit'
import {getConfig} from '../services/config'
import {residentPortalApi} from '../services/residentPortalApi'
import authReducer from './authSlice'
import userReducer from './userSlice'

const {reduxDevTools} = getConfig()

const combinedReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  [residentPortalApi.reducerPath]: residentPortalApi.reducer
})

let rootState: RootState

const isSignOut = ({type, payload}: AnyAction) =>
  type === 'auth/setAuthenticated' && payload === false

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  // sign out
  if (isSignOut(action)) {
    state = {} as RootState
  }
  rootState = combinedReducer(state, action)
  return rootState
}

export function getRootState() {
  return rootState
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().concat([residentPortalApi.middleware])
  },
  devTools: reduxDevTools
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
